import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { BasicModal } from 'Components/BasicModal';
import { Typography } from 'Components/Typography';

const CloseModalButton = styled.button`
  width: 100%;

  padding: 0;
  appearance: none;
  background: none;
  border: none;

  cursor: pointer;
`;

const StyledTypography = styled(Typography)`
  margin-left: auto;
  width: fit-content;
`;

const StyledModal = styled(BasicModal)`
  padding: ${theme.spacing['5x']} !important;
  background-color: ${theme.colors.neutral[200]};
`;

type InfoModalType = {
  isOpen: boolean;
  onClose: () => void;
  tooltipContent: React.ReactNode;
};

export const InfoModal = ({ isOpen, onClose, tooltipContent }: InfoModalType) => {
  return (
    <StyledModal hideClose isOpen={isOpen} onClose={onClose}>
      <Typography variant="p3">{tooltipContent}</Typography>
      <CloseModalButton onClick={() => onClose()}>
        <StyledTypography variant="mono3">close x</StyledTypography>
      </CloseModalButton>
    </StyledModal>
  );
};
